// extracted by mini-css-extract-plugin
module.exports = {"clients":"styles_clients__1L64g","list":"styles_list__3IoH4","scroll":"styles_scroll__ARD9f","listItems":"styles_listItems__1uvLK"};